<template>
  <div>
    <hello-world />
  </div>
</template>

<script>
import HelloWorld from "../components/HelloWorld";

export default {
  name: "Home",

  components: {
    HelloWorld,
  },
  mounted() {
    this.$utils.visit(this);
  },
};
</script>
